// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__x5qsT","savePackageButton":"ClientWallet_savePackageButton__3PDRP"};